export const apiBase = process.env.REACT_APP_API_BASE || "https://map.goodzonehotel.com.ua/api";
